module.exports = __webpack_public_path__ + "img/kneipp-verlag.76cf36a6.svg";